import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import WorkshopVerificationOverviewCard from './WorkshopVerificationOverviewCard';

const WorkshopVerificationOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:verification.overview.meta.title')} />
      <WorkshopVerificationOverviewCard />
    </ContentLayout>
  );
};

export default WorkshopVerificationOverviewPage;
